<template>
    <div>
        <NavBarLight></NavBarLight>
        <div class="content-start">
            <div class="container-fluid" id="main-container">
                <div class="row">
                     <div class="col-md-10 mx-auto text-left">
                        <h4>Submission</h4>
                        <SubmissionCard 
                            :title="challengeObj['.key']" 
                            :problem="challengeObj.Problem" 
                            :iconUrl="challengeObj.Icon" 
                            :instructions="challengeObj.Instructions_files"
                            :displayRequired="challengeObj.Display_reqd"
                            @submission="firebaseUpload">
                        </SubmissionCard>
                     </div>
                </div>
            </div>
           
        </div>
    </div>
</template>


<script>
import NavBarLight from '@/components/NavBarLight.vue'
import SubmissionCard from '@/components/SubmissionCard.vue'
import firebase from '../services/firebase'


export default {
    name: 'Submit',
    components: {
        NavBarLight,
        SubmissionCard
    },
    data: function() {
        return {
            challenges: []
        }
    },
    firebase: {
         challenges: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true)
    },
    computed: {
        challengeObj : function() {
            for (var key in this.challenges) {
                console.log("slug is " + this.challenges[key].Slug);
                if (this.challenges[key].Slug == this.$route.params.slug) {
                    console.log("slug is matched for " + this.challenges[key].Slug);
                    return this.challenges[key];
                }
            }
        }
    }, 
    methods: {
        firebaseUpload: function(pdfSubmission, displayImg) {
            console.log("received files object in firebaseUpload");
            const promises = [];
            var pdfUrl = '';
            var displayUrl = '';
            const downloadUrls = [];
            var date = "answered " + new Date().toDateString();
            var mytimestamp = new Date().getTime();
            var split_arr = firebase.auth().currentUser.email.split("@", 2);
            var uname = split_arr[0];
            var num_upvotes = 0;
            
            
            //Upload files
            var pdfLocation = "images/" + firebase.auth().currentUser.uid + 
            "/submissions/challenges/" + this.$route.params.slug + "/pdf/";
            var uploadTask = firebase.storage().ref().child("/" + pdfLocation).put(pdfSubmission);
            promises.push(uploadTask);
            

            var displayLocation = "images/" + firebase.auth().currentUser.uid + 
            "/submissions/challenges/" + this.$route.params.slug + "/displayImg/";
            var uploadPicTask = firebase.storage().ref().child("/" + displayLocation).put(displayImg);
            promises.push(uploadPicTask);
            
            
            
            //Read the file urls
            Promise.all(promises).then(tasks => {
                firebase.storage().ref().child("/" + pdfLocation).getDownloadURL().then((pdf_url) => {
                    firebase.storage().ref().child("/" + displayLocation).getDownloadURL().then((img_url) => {
                        console.log("download url of file is " + pdf_url);
                        pdfUrl = pdf_url;
                        console.log("download url of file is " + img_url);
                        displayUrl = img_url;

                        console.log("all tasks complete");
                        console.log("date created is " + date);
                        console.log("timestamp is " + mytimestamp);
                        console.log("challenge is " + this.challengeObj['.key']);
                        console.log("pdf_url is " + pdfUrl);

                        firebase.database().ref("/submissions/challenges/" + this.$route.params.slug + 
                        "/" + firebase.auth().currentUser.uid).set({
                            date_created: date,
                            timestamp: mytimestamp,
                            challenge: this.challengeObj['.key'],
                            display_img_url: displayUrl,
                            submission_url: pdfUrl,
                            user_id: firebase.auth().currentUser.uid,
                            email: firebase.auth().currentUser.email,
                            name: firebase.auth().currentUser.displayName,
                            photoURL: firebase.auth().currentUser.photoURL,
                            username: uname,
                            upvoted_by: [1, 2],
                            upvotes: num_upvotes,
                            approved: false
                        });

                        firebase.database().ref("/user_submissions/" + firebase.auth().currentUser.uid + "/" 
                        + this.$route.params.slug).set({
                            date_created: date,
                            timestamp: mytimestamp,
                            challenge: this.challengeObj['.key'],
                            display_img_url: displayUrl,
                            submission_url: pdfUrl,
                            user_id: firebase.auth().currentUser.uid,
                            email: firebase.auth().currentUser.email,
                            name: firebase.auth().currentUser.displayName,
                            photoURL: firebase.auth().currentUser.photoURL,
                            username: uname,
                            upvoted_by: [1, 2],
                            upvotes: num_upvotes,
                            approved: false
                        });

                        mixpanel.track("submission_done", {
                            "user_id": firebase.auth().currentUser.uid,
                            "challenge_name": this.$route.params.slug,
                            "email": firebase.auth().currentUser.email
                        });
                        
                        this.$router.push(this.$route.path + "/submitted");
                    });
                });
                
                
            });
        
            
        }
    }
}
</script>


<style scoped>

    .content-start {
        margin-top:58px;
    }

    @media (max-width: 400px) {
        .content-start {
            margin-top:100px;
        }
        
    }

    #main-container {
        background-color:#f8faff !important;
    }

</style>
